import Modal from './Common/Modal'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

interface ModalConfirmProps {
  title: string
  message: string
  onConfirm: () => void
  type?: 'error' | 'confirm'
  leftButtonLabel?: string
  rightButtonLabel?: string
  handleClose: () => void
}

export default function ModalConfirm({
  title,
  message,
  onConfirm,
  type,
  leftButtonLabel,
  rightButtonLabel,
  handleClose,
}: ModalConfirmProps) {
  const icon =
    type === 'confirm' ? (
      <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
    ) : (
      <XMarkIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
    )

  return (
    <Modal
      title={title}
      message={message}
      onConfirm={onConfirm}
      leftButtonLabel={leftButtonLabel}
      confirmButtonLabel={rightButtonLabel}
      handleClose={handleClose}
      icon={icon}
    />
  )
}
